import {take, call, fork, put} from 'redux-saga/effects'
import {
  SETTING_CHECKOUT_PAGE_REQUEST,
  SETTING_CHECKOUT_UPDATE_SETTING
} from 'actions/setting/checkout/constant'
import {
  getCheckoutSetting
} from 'sagas/api/checkout-setting'
import {
  putUpdateSetting
} from 'sagas/api/settings'
import {
  initialize
} from 'redux-form'
import {
  setSetting
} from 'actions/setting/checkout'
import * as actNotif from 'actions/notifications'
import * as mpSettingCheckout from 'mixpanel/settings/checkout'

export function * fillForm (data) {
  // see CheckoutForm for formname
  let formName = 'checkout'
  yield put(initialize(formName, {
    'tax': data.enable_tax,
    'gratuity': data.enable_gratuity,
    'includeGratuityTax': data.include_gratuity_tax.toString(),
    'trackServer': data.track_server
  }))
}

export function * pageRequestFlow () {
  // noinspection InfiniteLoopJS
  while (true) {
    yield take(SETTING_CHECKOUT_PAGE_REQUEST)
    mpSettingCheckout.settingCheckoutStart()
    let data = yield call(getCheckoutSetting, {})
    if (data) {
      yield call(fillForm, data)
      yield put(setSetting(data))
    }
  }
}

export function * updateSettingFlow () {
  // noinspection InfiniteLoopJS
  while (true) {
    let req = yield take(SETTING_CHECKOUT_UPDATE_SETTING)
    let {data} = req.payload
    mpSettingCheckout.settingCheckoutUpdate({
      settings: data.settings
    })
    let res = yield call(putUpdateSetting, data)
    if (res) {
      yield call(fillForm, res)
      yield put(actNotif.success(res.message))
    }
  }
}

export default function * settingCheckoutSaga () {
  yield fork(pageRequestFlow)
  yield fork(updateSettingFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/setting/checkout.js